import {
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from '@predoc/cow';
import { Link } from 'react-router';

export const AppSidebarHeader = () => {
  const { open } = useSidebar();

  return (
    <SidebarHeader>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton size="lg" asChild>
            <Link to="/">
              <img src="/predoc_nav_icon.svg" alt="Predoc" className="h-8" />
              {open ? (
                <img src="/predoc_text.svg" alt="Predoc" className="ml-2 h-8" />
              ) : null}
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
  );
};
